import { Hanko } from "@teamhanko/hanko-elements";

interface AuthProvider {
  isAuthenticated(): Promise<boolean | undefined>;
  user(): Promise<null | AuthenticatedUser>;
  signout(): Promise<void>;
  setUser(user: AuthenticatedUser): void;
  hanko(): Hanko;
}

const hankoApiURL = import.meta.env.VITE_HANKO_API_URL;
let hanko: Hanko;
let user: AuthenticatedUser | null;

export interface AuthenticatedUser {
  id: string;
  email?: string;
  subscription?: any; // Replace 'any' with the appropriate type for subscription
}

function getHanko() {
  if (!hanko) {
    hanko = new Hanko(hankoApiURL);
  }
  return hanko;
}

async function getUser() {
  if (!user) {
    const hanko = getHanko();
    try {
      if (await authProvider.isAuthenticated()) {
        const current = await hanko.getCurrentUser();
        const emails = current.emails ?? [];
        const primaryEmail = emails.find((e) => e.is_primary) ?? emails[0];
        user = {
          id: current.user_id,
          email: primaryEmail?.address,
        };
        const subscription = await getSubscription();
        user.subscription = subscription;
      }
    } catch {
      user = null;
    }
  }
  return user;
}

async function getSubscription() {
  const subscriptionApiUrl = import.meta.env.VITE_API_URL;
  try {
    const response = await fetch(`${subscriptionApiUrl}/subscription`,  { credentials: "include" });
    const {subscription, error} = await response.json();
    if (error) {
      throw new Error(error);
    }
    return subscription;
  } catch (error) {
    console.error('Error fetching subscription status:', error);
    return null;
  }
}

export const authProvider: AuthProvider = {
  async isAuthenticated() {
    const hanko = getHanko();
    const session = await hanko.validateSession();
    return session.is_valid;
  },
  async user() {
    console.time("fetching user");
    user = await getUser();
    console.timeEnd("fetching user");
    return user;
  },
  async signout() {
    user = null;
    const hanko = getHanko();
    await hanko.logout();
  },
  setUser(newUser) {
    user = newUser;
  },
  hanko() {
    if (!hanko) {
      hanko = new Hanko(hankoApiURL);
    }
    return hanko;
  },
};
